// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import {useLocalSearchParams, useRouter} from "expo-router"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import SignInForm from "../../src/auth/sign-in-form"
import buildRoutePath from "../../src/shared/build-route-path"
import ScreenTitle from "../../src/components/screen-title"


/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} SignInScreenProps */

/** @typedef {Record<string, never>} SignInScreenState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<SignInScreenProps, SignInScreenState>}
 */
class SignInScreen extends ShapeComponent {
  /** @type {ReturnType<typeof useRouter>} */
  router
  /** @type {ReturnType<typeof useLocalSearchParams>} */
  params

  /** Initializes route hooks. */
  setup() {
    this.params = useLocalSearchParams()
    this.router = useRouter()
  }

  /** Navigates to the front page after a successful sign-in. */
  onSignInSuccess = () => {
    this.router.replace(buildRoutePath(this.params, "/"))
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Sign in")}</ScreenTitle>
        <SignInForm onSignInSuccess={this.tt.onSignInSuccess} />
      </>
    )
  }
}

/** @type {NamedExoticComponent<SignInScreenProps>} */
const SignInScreenComponent = memo(shapeComponent(SignInScreen))

export default SignInScreenComponent
